export enum UserStatusId {
  Active = 1,
  Disabled = 2,
}
